import React, { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { Form, Button } from 'react-bootstrap';
import api from '../../services/api';
import { toast } from 'react-toastify';
import { useUser } from '../../contexts/UserContext';

const PASSWORD_REQUIREMENTS = [
    { test: (p) => p.length >= 12, label: 'At least 12 characters' },
    { test: (p) => /[A-Z]/.test(p), label: 'At least 1 uppercase letter' },
    { test: (p) => /[a-z]/.test(p), label: 'At least 1 lowercase letter' },
    { test: (p) => /[0-9]/.test(p), label: 'At least 1 number' },
    { test: (p) => /[^A-Za-z0-9]/.test(p), label: 'At least 1 special character' },
];

const ChangePassword = () => {
    const [oldPassword, setOldPassword] = useState('');
    const [newPassword, setNewPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [passwordErrors, setPasswordErrors] = useState([]);
    const [loadingData, setLoadingData] = useState(false);
    const { user } = useUser();
    const history = useHistory();

    const validatePassword = (password) => {
        return PASSWORD_REQUIREMENTS.filter(req => !req.test(password)).map(req => req.label);
    };

    const saveData = async (e) => {
        e.preventDefault();

        const errors = validatePassword(newPassword);
        if (errors.length > 0) {
            setPasswordErrors(errors);
            return;
        }

        if (newPassword !== confirmPassword) {
            toast.error('New passwords do not match.', { position: toast.POSITION.TOP_RIGHT });
            return;
        }

        setPasswordErrors([]);
        setLoadingData(true);

        try {
            const response = await api.post('auth/change-password', {
                old_password: oldPassword,
                new_password: newPassword,
            });
            if (response.status === 200) {
                toast.success('Password updated successfully!', { position: toast.POSITION.TOP_RIGHT });
                history.goBack();
            }
        } catch (error) {
            const detail = error.response?.data?.detail || 'Failed to change password.';
            toast.error(detail, { position: toast.POSITION.TOP_RIGHT });
        } finally {
            setLoadingData(false);
        }
    };

    useEffect(() => {
        var selector = document.getElementById('title-section-id');
        if (selector != undefined) {
            selector.textContent = "Change Password";
        }
    }, []);

    return (
        <>
            <div className={loadingData ? "preload" : "d-none"}><div className="preloader-spinner"></div></div>
            <Form className="create-form" onSubmit={saveData} autoComplete="off">
                <div className="card">
                    <div className="card-body">
                        <p className="text-muted mb-4">
                            Changing password for <strong>{user?.email}</strong>
                        </p>
                        <div className="row">
                            <div className="mb-3 col-md-6 col-sm-12">
                                <Form.Group className="form-group">
                                    <Form.Label>Current Password</Form.Label>
                                    <Form.Control name="old_password" type="password" required placeholder="Current Password" value={oldPassword} onChange={(e) => setOldPassword(e.target.value)} />
                                </Form.Group>
                            </div>
                        </div>
                        <div className="row">
                            <div className="mb-3 col-md-6 col-sm-12">
                                <Form.Group className="form-group">
                                    <Form.Label>New Password</Form.Label>
                                    <Form.Control name="new_password" type="password" required placeholder="New Password" value={newPassword} onChange={(e) => { setNewPassword(e.target.value); setPasswordErrors([]); }} />
                                    {passwordErrors.length > 0 && (
                                        <ul className="text-danger mt-1 mb-0" style={{fontSize: '0.85em', paddingLeft: '1.2em'}}>
                                            {passwordErrors.map((err, i) => <li key={i}>{err}</li>)}
                                        </ul>
                                    )}
                                </Form.Group>
                            </div>
                            <div className="mb-3 col-md-6 col-sm-12">
                                <Form.Group className="form-group">
                                    <Form.Label>Confirm New Password</Form.Label>
                                    <Form.Control name="confirm_password" type="password" required placeholder="Confirm New Password" value={confirmPassword} onChange={(e) => setConfirmPassword(e.target.value)} />
                                </Form.Group>
                            </div>
                        </div>
                    </div>
                    <div className="card-footer">
                        <div className="row">
                            <div className="col-12 footer-form">
                                <Button className="btn btn-secondary" onClick={() => history.goBack()}><i className="fa fa-fw fa-times"></i> Cancel</Button>
                                <Button className="btn btn-primary" type="submit"><i className="fa fa-fw fa-floppy-o"></i> Save</Button>
                            </div>
                        </div>
                    </div>
                </div>
            </Form>
        </>
    );
};

export default ChangePassword;
